import { createFileRoute } from "@tanstack/react-router";
import Page, { seo } from "@/pages/services/ai-web-app-design";
import { buildServiceHead } from "@/lib/service-seo";

export const Route = createFileRoute("/services/ai-web-app-design")({
  head: () => buildServiceHead(seo),
  component: Page,
});
